// extracted by mini-css-extract-plugin
module.exports = {"btn":"AnimatedButton_btn___7p4W"};